export const getActivationHelpLink = license => {
  if (!license) return;
  switch (license.type) {
    case 'nuitrack':
      if (license.config.product === 'tvico')
        return '/external_resource/link/nuitrack_docs_tvico_user_guide/';
      return '/external_resource/link/nuitrack_docs_installation/';
    case 'face':
      if (
        (license.config.product === 'face_offline_custom' ||
          license.config.product === 'face_offline_perpetual') &&
        license.config.device_bound &&
        license.activations.length <= 0
      )
        return '/external_resource/link/face_sdk_docs_offline_license/';
      else if (license.locked_to === 'usb_token')
        return '/external_resource/link/face_sdk_docs_locking_to_a_usb_token/';
      else return '/external_resource/link/face_sdk_docs_license_activation/';
    default:
      return;
  }
};
